<mat-dialog-content xmlns="http://www.w3.org/1999/html">
  <h2>{{ "admin.dialogs.edit" | translate }} {{data.keyFigures}} percentages</h2>
  <mat-card-content>
    <form (submit)="sendEditionRequest()" [formGroup]="errorEditForm">
      <div class="form-container">
        <mat-form-field appearance="fill">
          <mat-label>{{ "admin.errors.percentage" | translate }}</mat-label>
          <input [formControl]="percentageControl" matInput type="number"/>
        </mat-form-field>
        <div class="edit-dialog-buttons-container">
          <button mat-raised-button (click)="closeDialog()" type="button" >
            <span>Close</span>
          </button>
          <button mat-raised-button color="primary" type="submit">
            <span>Save</span>
          </button>
        </div>
      </div>
    </form>
  </mat-card-content>
</mat-dialog-content>
